export default __webpack_public_path__ + "static/media/KC_Storefront_banner.0333a0f3.png";